const geoTypes = {
  wms: {
    shortName: 'wms',
    icon: 'http',
    cssClass: 'deep-purple white--text',
    title: 'WMS to …',
    usage: 'a vector based web service URL (ie. http://)',
  },
  wfs: {
    shortName: 'wfs',
    icon: 'http',
    cssClass: 'teal white--text',
    title: 'WFS to …',
    usage: 'a raster based web service (ie. http://)',
  },
  vector: {
    shortName: 'vector',
    icon: 'file_upload',
    cssClass: 'blue-grey white--text',
    title: 'Vector File to …',
    usage: 'For example a shapefile you want to convert to a GeoPackage.',
  },
  raster: {
    shortName: 'raster',
    icon: 'file_upload',
    cssClass: 'brown white--text',
    title: 'Raster File to …',
    usage: 'For example a GeoTIFF you want to convert to a PNG.',
  },
};

export default geoTypes;



// WEBPACK FOOTER //
// ./src/components/converter/helpers/geoTypes.js